import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  token: null,
  user: null,
  allClients: [],
  registerSuccess: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginStart(state) {
      state.loading = true;
      state.error = null;
    },
    loginSuccess(state, action) {
      state.loading = false;
      state.error = null;
      state.token = action.payload.token;
      state.user = action.payload.user;
    },
    loginFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    //registration reducer
    registerStart(state) {
      state.loading = true;
      state.error = null;
      state.registerSuccess = false;
    },
    registerSuccess(state) {
      state.loading = false;
      state.error = null;
      state.registerSuccess = true;
    },
    registerFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.registerSuccess = false;
    },
    //  logout reducer
    logout(state) {
      state.loading = false;
      state.error = null;
      state.token = null;
      state.user = null;
      state.allClients = [];
    },

    clearError(state) {
      state.error = null;
    },
  },
});

export const {
  loginStart,
  loginSuccess,
  loginFailure,
  registerStart,
  registerSuccess,
  registerFailure,
  logout,
  clearError,
} = authSlice.actions;

export default authSlice.reducer;
